import { useEffect } from 'react'
import { Box, Text } from '@redriverpress/system'
import {
  setStepsLength,
  useStudentOnboardingContext,
} from '../../context/onboardingStudentContext'

const stepSize = [null, null, '3rem', '4rem']
const { innerHeight } = window

export default function Stepper() {
  const [
    { currentStep, isInvitation, isSm, stepsLength },
    dispatch,
  ] = useStudentOnboardingContext()

  const setBorderColor = step =>
    !!currentStep && currentStep >= step ? 'blue500' : 'white'

  const setBackgroundColor = step =>
    !!currentStep && currentStep > step ? 'blue500' : 'white'

  const setColor = step => {
    if (currentStep === step) return 'blue500'
    if (!!currentStep && currentStep > step) {
      return 'white'
    }
    return 'black'
  }

  useEffect(() => {
    dispatch(setStepsLength(isInvitation ? 4 : 5))
  }, [])

  return isSm ? (
    <Box display='flex' alignItems='center' position='absolute' top='1.5rem'>
      <Box
        borderRadius='circular'
        border='solid 2px'
        background='white'
        borderColor='blue500'
        width='2rem'
        height='2rem'
        color='blue500'
        textAlign='center'
        mr={1}
        lineHeight='1.625rem'
      >
        {currentStep}
      </Box>
      <Text color='gray800'>of {stepsLength}</Text>
    </Box>
  ) : (
    <Box
      position='absolute'
      top='50%'
      style={{ transform: 'translate(0, -50%)' }}
    >
      {[...new Array(stepsLength)].map((step, idx) => {
        return (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={idx}
            display='flex'
            flexDirection='column'
            alignItems='center'
          >
            <Box
              borderRadius='circular'
              width={stepSize}
              height={stepSize}
              display='flex'
              alignItems='center'
              justifyContent='center'
              boxShadow={2}
              border='solid 3px'
              borderColor={setBorderColor(idx + 1)}
              backgroundColor={setBackgroundColor(idx + 1)}
            >
              <Box
                m={0}
                p={0}
                fontSize={[3, null, null, 4]}
                fontWeight='600'
                color={setColor(idx + 1)}
              >
                {idx + 1}
              </Box>
            </Box>
            {idx + 1 !== stepsLength && (
              <Box
                width='0.25rem'
                height={innerHeight / stepsLength - 80}
                backgroundColor='gray150'
              />
            )}
          </Box>
        )
      })}
    </Box>
  )
}
